import {inject, Injectable, Type} from '@angular/core';
import {ModalsService} from "../../../../services/modals.service";
import {BloggerModalService} from "./blogger-modal.service";
import {BaseModalService} from "../../services/base-modal.service";
import {UtilityService} from "../../../../services/utility.service";
import {RecordData, RecordDataValue} from "../../../../types/records-table.types";
import {HeaderItem} from "../types/blogger-card.types";
import {BloggerProfileDialogData} from "../types/blogger-modal.types";
import {resources} from "../../../../models/resource/resources";
import {RecordTableAction} from "../../../../types/record-table-action.types";
import {DetachProps} from "../../../../types/attach-detach.types";
import {bloggerModalResourceType} from "../configs/blogger-modal-config";
import {BloggerModalComponents} from "../types/current-blogger-card-modal.types";
import {EditBloggerModalComponent} from "../edit-blogger-modal/edit-blogger-modal.component";
import {
  CreateProfileBloggerModalComponent
} from "../create-profile-blogger-modal/create-profile-blogger-modal.component";
import {EditProfilesBloggerModalComponent} from "../edit-profiles-blogger-modal/edit-profiles-blogger-modal.component";
import {
  DeleteProfileBloggerModalComponent
} from "../delete-profile-blogger-modal/delete-profile-blogger-modal.component";

@Injectable({
  providedIn: 'root'
})
export class CurrentBloggerProfileService {
  private modalService: ModalsService = inject(ModalsService);
  private bloggerModalService: BloggerModalService = inject(BloggerModalService);
  private baseModalService: BaseModalService = inject(BaseModalService);
  private utilityService: UtilityService = inject(UtilityService);

  public headerItems(bloggerCardHeader: RecordData | null | undefined): Array<HeaderItem> {
    return [
      {
        value: `${bloggerCardHeader?.['subscribersCount'] || 0} тыс. подписчиков`
      },
      {
        value: `${bloggerCardHeader?.['videosCount'] || 0} видео`
      },
      {
        value: `Id ${bloggerCardHeader?.id}`
      },
      {
        value: `Рекламный рейтинг ${bloggerCardHeader?.['bloggerRating'] || 'Не установлен'}`,
        needBtn: true,
        btnClass: 'btn-update-rating',
        iconClass: 'icon-update',
        iconName: 'update'
      },
      {
        value: `Рекламный счёт ${this.formatNumberValue(bloggerCardHeader?.['bloggerScore']) || 0}`,
        last: true
      }
    ];
  }

  public async handleButtonClick(key: string, dialogData: BloggerProfileDialogData): Promise<void> {
    const { recordData } = dialogData;

    recordData['blogger'] = {
      id: Number(dialogData.bloggerId)
    };


    if (key in recordData && 'bloggerId' in (recordData[key] as RecordData)) {
      (recordData[key] as RecordData)['bloggerId'] = dialogData.bloggerId;
    }

    key === 'bloggerContact' ?
      await this.modalService.getStatusFromContactModal(key, recordData, true) :
      await this.modalService.openBankDetails(key, recordData, true);
  }

  public async checkIfBloggerCanBeUnbound(dialogData: BloggerProfileDialogData): Promise<boolean> {
    return await this.bloggerModalService.getBloggerUnbindStatus({
      path: resources['record-lists'].path,
      id: dialogData.parentResourceId
    }).catch(() => false);
  }

  public getActionList(canBloggerUnbind: boolean, bloggerCardHeader: RecordData | null | undefined): Array<RecordTableAction> {
    const actions: Array<RecordTableAction> = ['EDIT_BLOGGER', 'CREATE_PROFILE_BLOGGER'];
    if (canBloggerUnbind) {
      actions.unshift('UNBIND_BLOGGER');
    }

    const hasProfiles = (bloggerCardHeader?.['profiles'] as Array<RecordData>)?.length;
    if (hasProfiles) {
      actions.push('EDIT_PROFILES_BLOGGER', 'DELETE_PROFILE_BLOGGER');
    }

    return actions;
  }

  public async updateRating(id: number): Promise<void> {
    await this.bloggerModalService.updateRating(id);
  }

  public getDetachProps(dialogData: BloggerProfileDialogData): DetachProps {
    return {
      path: bloggerModalResourceType.path,
      recordCalendarId: this.baseModalService.getRecordCalendarId(dialogData.recordData)
    };
  }

  public getModalType(action: string): Type<BloggerModalComponents> {
    switch (action) {
      case "EDIT_BLOGGER":
        return EditBloggerModalComponent;
      case "CREATE_PROFILE_BLOGGER":
        return CreateProfileBloggerModalComponent;
      case "EDIT_PROFILES_BLOGGER":
        return EditProfilesBloggerModalComponent;
      case 'DELETE_PROFILE_BLOGGER':
        return DeleteProfileBloggerModalComponent
      default:
        return EditBloggerModalComponent;
    }
  }

  private formatNumberValue(value: RecordDataValue): string | null {
    if (value === null || value === undefined) { return null; }

    return this.utilityService.formatNumberForDisplay({
      value: +value
    });
  }
}
